import * as React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import Grid from '@mui/material/Grid2'

export const Wrapper = styled(({ isTasksExist, ...props }) => <Grid {...props} />)`
  && {
    width: calc(100% - 39px);

    ${({ isTasksExist }) =>
      !isTasksExist &&
      css`
        margin-left: 16px;
        width: calc(100% - 16px);
      `};

    & > div:not(:first-child) {
      margin-left: 8px;
    }

    @media (max-width: 768px) {
      border-radius: 0;
      padding-right: 8px;

      & > div:nth-child(1) {
        width: 100%;
      }

      & > div:nth-child(2) {
        margin: 8px 0;
      }
    }
  }
`

export const Details = styled((props) => <Grid {...props} />)`
  align-items: baseline;
  display: flex;
  flex-grow: 1;
  white-space: nowrap;
  width: 10%;

  & > div {
    margin-right: 4px;
  }

  &:first-child {
    display: flex;
    font-size: 18px;
    overflow: hidden;

    > :first-child {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &:nth-child(2) {
    display: flex;
    font-size: 12px;
  }
`
